import i18next from 'i18next';
import * as React from 'react';
import { StandardLocalWidget, any, fromJSX, nothing } from "widgets-for-react";
import { FormControls } from '../../utils/forms';
import { singleValidatorResultBuilders } from "../../validator/validator";
import { companyWidget } from "../../forms/company/companyWidget";
import { paymentMethodWidget } from "../../forms/paymentMethod/paymentMethodWidget";
import { RootLayout } from '../../site/root/rootLayout';
import { SubscriptionLayout } from "../subscriptionLayout";
import { SubscriptionState, subscriptionUpdaters } from "../subscriptionState";
import { resumeSubscriptionInputUpdaters } from "./resumeSubscriptionState";

export const resumeSubscriptionWidget: StandardLocalWidget<SubscriptionState> = currentState =>
  currentState.kind != "resume subscription flow" ?
    nothing() :
    any([
      currentState.resumeSubscription.kind == "loaded" ?
        fromJSX(() =>
          currentState.resumeSubscription.kind == "loaded" ?
            currentState.resumeSubscription.value.Kind == "Redirect" ?
              <SubscriptionLayout.RedirectToPsp
                variant="other"
                redirectUrl={currentState.resumeSubscription.value.RedirectUrl}
              />
              : currentState.resumeSubscription.value.Kind == "Success" ?
                <SubscriptionLayout.ThankYou
                  variant="subscription-success"
                  subscriptionState={currentState}
                  thankYouMessage={i18next.t("subscription:SubscriptionResumedThankYouMessage")}
                />
                : <SubscriptionLayout.FailureOrCancel
                  variant="subscription-failure"
                />
            : <></>
        )
        :
        fromJSX(setState =>
          <>
            {currentState.userSubscriptions.kind == "loaded" && currentState.userSubscriptions.value.HasOriginalTransactionKey ? <></> :
              <>
                <FormControls.FormCheckInGroup
                  controlId="subscriptionInvoiceAddressDifferent"
                  label={i18next.t("subscription:InvoiceToCompany")}
                  checked={currentState.resumeSubscriptionInput.invoiceToCompany || false}
                  required={false}
                  onChange={(newValue => setState(subscriptionUpdaters.resumeSubscriptionInput(resumeSubscriptionInputUpdaters.invoiceToCompany(_ => newValue))))}
                  validation={singleValidatorResultBuilders.validating("")}
                />
                {
                  currentState.resumeSubscriptionInput.invoiceToCompany ?
                    currentState.lookupData.kind == "loaded" ?
                      companyWidget(currentState.lookupData.value.Countries, currentState.lookupData.value.CompanyTypes, false, currentState.userSubscriptions.kind === "loaded" && currentState.userSubscriptions.value.User.Country !== null, true)(currentState.resumeSubscriptionInput.companyState)
                        .map(resumeSubscriptionInputUpdaters.companyState)
                        .map(subscriptionUpdaters.resumeSubscriptionInput)
                        .run(setState)
                      : <RootLayout.Loader hasWrapper showText />
                    : <></>
                }
                {
                  currentState.lookupData.kind == "loaded" ?
                    paymentMethodWidget(currentState.lookupData.value.IDealIssuers)(currentState.resumeSubscriptionInput.paymentMethodState)
                      .map(resumeSubscriptionInputUpdaters.paymentMethodState)
                      .map(subscriptionUpdaters.resumeSubscriptionInput)
                      .run(setState)
                    : <RootLayout.Loader hasWrapper showText />
                }
              </>
            }
            <SubscriptionLayout.ActionAndBackButtons
              back={() => setState(subscriptionUpdaters.overview)}
              action={() => setState(subscriptionUpdaters.invokeResumeApi)}
              actionText={i18next.t("subscription:ResumeSubscription")}
              actionDisabled={false}
            />
          </>
        )
    ])
